var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 67.48,
    y1: 22.51,
    x2: 22.52,
    y2: 67.48,
    gradientTransform: "translate(11.66 -9.21) rotate(13.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5d30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba411f"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(-9.21 11.66) rotate(-13.41)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.39,40.77q-8.8,6-13.38,9.28c-1,.75-1.85,1.34-2.49,1.76A15.16,15.16,0,0,1,48,53.1a7.66,7.66,0,0,1-2.95.65H45A7.66,7.66,0,0,1,42,53.1a15.16,15.16,0,0,1-2.54-1.29c-.64-.42-1.47-1-2.49-1.76q-3.63-2.67-13.35-9.28a14.29,14.29,0,0,1-2.72-2.33V59.77a4.3,4.3,0,0,0,4.3,4.3H64.78a4.3,4.3,0,0,0,4.3-4.3V38.44a14.5,14.5,0,0,1-2.69,2.33ZM25.54,37.59h0a13.17,13.17,0,0,1-3.14-3.11,6.23,6.23,0,0,1-1.48-3.66A5.4,5.4,0,0,1,22,27.32a3.82,3.82,0,0,1,3.18-1.39H64.78a4.34,4.34,0,0,1,4.3,4.3,7.08,7.08,0,0,1-1.32,4.05,12.74,12.74,0,0,1-3.28,3.31L51.91,46.32l-1.15.82c-.58.42-1.06.76-1.45,1s-.85.55-1.39.88a8.42,8.42,0,0,1-1.55.72A4.27,4.27,0,0,1,45,50H45a4.27,4.27,0,0,1-1.34-.24A8.42,8.42,0,0,1,42.08,49c-.54-.33-1-.62-1.39-.88s-.87-.6-1.45-1l-1.15-.82c-1.63-1.14-4-2.78-7-4.9Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmail);
export default __webpack_public_path__ + "static/media/share-email.f4238a270c771dde777bc11db6638f1d.svg";
export { ForwardRef as ReactComponent };